module.exports = __webpack_public_path__ + "img/divison_log.0380d2ef.png";